import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
import { ChevronIcon } from './icons/Icons';
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const {
    language
  } = useLanguage();
  const toggleFAQ = (idx: number) => {
    setOpenIndex(prev => prev === idx ? null : idx);
  };
  const faqs = [{
    question: language === 'es' ? '¿Con cuánta anticipación debo agendar mi cita?' : 'How far in advance should I book my appointment?',
    answer: language === 'es' ? 'Recomiendo agendar con al menos 1-2 semanas de anticipación, ya que los cupos son limitados para garantizar una atención 1 a 1 sin prisas.' : 'I recommend booking at least 1-2 weeks in advance, as spots are limited to guarantee unhurried 1-on-1 attention.'
  }, {
    question: language === 'es' ? '¿Qué debo hacer antes de mi primer facial?' : 'What should I do before my first facial?',
    answer: language === 'es' ? 'Evita la exposición solar directa y no uses productos exfoliantes (como retinoides o ácidos) 3 días antes de tu cita. Ven con la piel limpia o con tu maquillaje habitual, lo retiraremos aquí.' : 'Avoid direct sun exposure and do not use exfoliating products (like retinoids or acids) 3 days before your appointment. Come with clean skin or your usual makeup, we will remove it here.'
  }, {
    question: language === 'es' ? 'Tengo acné activo, ¿puedo hacerme un facial?' : 'I have active acne, can I get a facial?',
    answer: language === 'es' ? '¡Absolutamente! De hecho, es el mejor momento. Como Medical Assistant, evaluaré tu tipo de acné y personalizaré el tratamiento para desinflamar y tratar los brotes de manera segura.' : "Absolutely! In fact, it's the best time. As a Medical Assistant, I will evaluate your type of acne and personalize the treatment to reduce inflammation and treat breakouts safely."
  }, {
    question: language === 'es' ? '¿Cuáles son las políticas de cancelación?' : 'What are the cancellation policies?',
    answer: language === 'es' ? 'Entiendo que surgen imprevistos. Te pido cancelar o reprogramar con al menos 24 horas de anticipación para poder ofrecer ese espacio a otra paciente.' : 'I understand that unforeseen events arise. I ask that you cancel or reschedule at least 24 hours in advance so I can offer that spot to another patient.'
  }];
  return <section id="faq" className="py-20 bg-brand-cream relative" data-id="element-75">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-76">
        <div className="text-center mb-12" data-id="element-77">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-78">
            {language === 'es' ? 'Preguntas Frecuentes' : 'Frequently Asked Questions'}
          </h2>
          <p className="text-brand-charcoal/70" data-id="element-79">
            {language === 'es' ? 'Todo lo que necesitas saber antes de tu visita.' : 'Everything you need to know before your visit.'}
          </p>
        </div>

        <div className="space-y-4" data-id="element-80">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="border border-brand-gold/20 rounded-xl bg-white overflow-hidden shadow-sm" data-id="element-81">
              <button onClick={() => toggleFAQ(idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === idx} data-id="element-82">
                <span className="text-lg font-medium text-brand-charcoal pr-4" data-id="element-83">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="text-brand-gold flex-shrink-0" data-id="element-84">
                  <ChevronIcon size={20} data-id="element-85" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-86">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-87">
                    <div className="px-6 pb-6 pt-2 text-brand-charcoal/70 leading-relaxed border-t border-brand-cream mx-6" data-id="element-88">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};